import React from "react";
import PropTypes from "prop-types";
import { format as formatFn, parse as parseFn, setHours, setMinutes, getHours, getMinutes } from "date-fns";
import BaseField from "./BaseField";
import DateField from "./DateField";
import TimeField from "./TimeField";
import { ThemeProvider } from "styled-components/native";

/**
 * Theme used to reset to 0 the field borders, background transparent and radius 0,
 * for its implementation where it is used according to the use of ThemeProvider.
 */
const resetCeroTheme = {
  fieldBorderTopWidth: 0,
  fieldBorderRightWidth: 0,
  fieldBorderBottomWidth: 0,
  fieldBorderLeftWidth: 0,
  fieldBackgroundColor: "transparent",
  fieldBorderRadius: 0,
  fieldMinHeight: 32,

  fieldStyle: "background-color: transparent;"
};
const DateTimeField = ({
  dateValue,
  timeValue,
  onTimeChange,
  onDateChange,
  onTimeBlur,
  onDateBlur,
  dateParseFormat,
  timeParseFormat,
  parseFormat,
  editable,
  ...restProps
}) => (
  <BaseField {...restProps}>
    <ThemeProvider theme={resetCeroTheme}>
      <React.Fragment>
        <DateField
          value={dateValue}
          flex={0.6}
          parseFormat={dateParseFormat}
          onChangeText={text => onDateChange(text, timeValue)}
          onBlur={onDateBlur}
          editable={editable}
        />

        <TimeField
          value={timeValue}
          flex={0.4}
          parseFormat={timeParseFormat}
          onChangeText={text => onTimeChange(dateValue, text)}
          onBlur={onTimeBlur}
          editable={editable}
        />
      </React.Fragment>
    </ThemeProvider>
  </BaseField>
);

DateTimeField.defaultProps = {
  onTimeChange: () => {},
  onDateChange: () => {},
  onTimeBlur: () => {},
  onDateBlur: () => {},
  dateParseFormat: "yyyy-MM-dd",
  timeParseFormat: "HH:mm",
  parseFormat: "yyyy-MM-dd'T'HH:mm:ssXX"
};

export default DateTimeField;
